import { render, staticRenderFns } from "./UpdateInternationProduct.vue?vue&type=template&id=527c55d3&scoped=true"
import script from "./UpdateInternationProduct.vue?vue&type=script&lang=js"
export * from "./UpdateInternationProduct.vue?vue&type=script&lang=js"
import style0 from "./UpdateInternationProduct.vue?vue&type=style&index=0&id=527c55d3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c55d3",
  null
  
)

export default component.exports